<template>
  <v-container class="pa-0" fluid>
    <div class="pt-4">
      <v-card outlined>
        <v-card-title class="pt-2">
          <h3>{{ $t('Objektai') }}</h3></v-card-title
        >
        <v-card-text>
          <el-overlay-loading dashboard :loading="pageloading" />
          <v-row class="pt-1 pb-3"> </v-row>
          <v-divider />
          <v-row class="pt-1 pb-3">
            <v-col cols="12" md="12" lg="8">
              <LineChartGenerator
                :chart-options="chartOptions"
                :chart-data="chartData"
                :chart-id="chartId"
                :dataset-id-key="datasetIdKey"
                :plugins="plugins"
                :css-classes="cssClasses"
                :styles="styles"
                :width="width"
                :height="height"
              />
            </v-col>
            <v-col v-if="true" cols="12" md="12" lg="4">
              <el-autocomplete
                @change="updateBoard()"
                :items="kinds"
                direct
                multiple
                hide-details
                itemvalue="value"
                itemtext="text"
                label="Objektų vaizdavimas"
                v-model="formData.kind"
              />

              <br />

              <el-autocomplete
                @change="updateBoard()"
                :items="formatedTerms"
                enums
                hide-details
                itemvalue="value"
                itemtext="text"
                label="Žingsnis"
                v-model="formData.period"
              />

              <br />

              <el-autocomplete
                @change="updateBoard()"
                v-for="(item, index) in yearSelects"
                :key="index"
                :items="formatedYears"
                direct
                hide-details
                itemvalue="value"
                itemtext="text"
                label="Metai"
                v-model="formData[item]"
                classP="pb-2"
              />
              <v-btn
                v-if="yearSelects.length < 10"
                @click="setYearSelect(false)"
                class="mr-2"
                active-class="active-btn-group-item"
                small
                color="primary"
                value="by-service"
                >+ Pridėti naują</v-btn
              >
              <v-btn
                v-if="yearSelects.length > 1"
                @click="setYearSelect(true)"
                class="mr-2"
                active-class="active-btn-group-item"
                small
                color="danger"
                value="by-service"
                >X</v-btn
              >
              <!-- <export-btn
                small
                object="registered-objects"
                :id="chartId"
              ></export-btn> -->
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </div>
  </v-container>
</template>

<script>
import { Line as LineChartGenerator } from 'vue-chartjs/legacy'
import Enums from '@/enums'

const customLabels = {
  id: 'customLabels',
  afterDatasetsDraw: (chart, args, opts) => {
    const ctx = chart.ctx
    const datasets = chart.data.datasets

    datasets.forEach((dataset, datasetIndex) => {
      const meta = chart.getDatasetMeta(datasetIndex)
      if (!meta.hidden) {
        meta.data.forEach((element, index) => {
          const dataPoint = dataset.data[index] || ''
          const x = element.x
          const y = element.y

          ctx.fillStyle = 'black' // Customize label color
          ctx.font = '10px Arial' // Change font size to 10
          ctx.textAlign = 'center'
          ctx.fillText(dataPoint, x, y - 10) // Display dataPoint value above the bar
        })
      }
    })
  },
}

import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  LineElement,
  LinearScale,
  CategoryScale,
  PointElement,
} from 'chart.js'

ChartJS.register(
  Title,
  Tooltip,
  Legend,
  LineElement,
  LinearScale,
  CategoryScale,
  PointElement
)

export default {
  name: 'RegisteredObjectsForm',
  components: {
    LineChartGenerator,
  },
  data() {
    return {
      pageloading: false,
      //
      formData: {},
      chartData: {},
      chartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          y: {
            ticks: {
              callback: function (value) {
                return value.toString()
              },
            },
          },
        },
        plugins: {
          tooltip: {
            callbacks: {
              label: function (context) {
                let label = context.dataset.label || ''
                if (label) {
                  label += ': '
                }
                if (context.parsed.y !== null) {
                  label += context.parsed.y.toString()
                }
                return label
              },
            },
          },
          customLabels: {
            display: true,
          },
        },
      },
      //
      chartId: 'registered-objects-chart',
      datasetIdKey: 'label',
      width: 400,
      height: 300,
      cssClasses: '',
      styles: {},
      plugins: [customLabels],
      yearSelects: ['year0'],
      colors: [
        'rgba(0, 76, 76, 1)',
        'rgba(255, 153, 102, 1)',
        'rgba(178, 216, 216, 1)',
        'rgba(255, 204, 92, 1)',
        'rgba(19, 122, 127, 1)',
        'rgba(153, 153, 153, 1)',
        'rgba(255, 82, 82, 1)',
        'rgba(0, 80, 115, 1)',
        'rgba(255, 186, 186, 1)',
        'rgba(17, 17, 17, 1)',
      ],
    }
  },
  computed: {
    kinds() {
      return [
        {
          text: 'Įregistruoti',
          value: 'registered',
        },
        {
          text: 'Išregistruoti',
          value: 'deregistered',
        },
      ]
    },
    formatedTerms() {
      return Enums.filterStep
    },
    formatedYears() {
      let years = []
      let year = new Date().getFullYear()
      while (year >= 2010) {
        years.push(year.toString())
        year--
      }
      return years
    },
  },
  created() {
    this.$set(this.formData, 'period', 'months3')
    this.$set(this.formData, 'year0', new Date().getFullYear().toString())
    this.$set(this.formData, 'kind', ['registered', 'deregistered'])
    this.getData()
  },
  methods: {
    getData() {
      this.pageloading = true
      this.formData.year = this.getYears()

      this.$axios
        .post(`dashboard/registered`, this.formData)
        .then((res) => {
          this.chartData = {
            labels: res.data.labels,
            datasets: [],
          }

          let i = 0
          for (let year of this.formData.year) {
            if (year === undefined) {
              continue
            }
            if (res.data.data[year + ' Įregistruoti']) {
              this.addDataset(
                i++,
                year + ' Įregistruoti',
                res.data.data[year + ' Įregistruoti']
              )
            }
            if (res.data.data[year + ' Išregistruoti']) {
              this.addDataset(
                i++,
                year + ' Išregistruoti',
                res.data.data[year + ' Išregistruoti']
              )
            }
          }

          this.pageloading = false
        })
        .catch((err) => {
          this.$root.$emit('DATA_ERROR', err)
          this.pageloading = false
        })
    },
    updateBoard() {
      this.getData()
    },
    addDataset(index, label, data) {
      this.chartData.datasets.push({
        label: label,
        backgroundColor: this.colors[index % 10],
        borderColor: this.colors[index % 10],
        data: data,
      })
    },
    getYears() {
      let years = []
      let formData = this.formData
      this.yearSelects.forEach(function (year) {
        years.push(formData[year])
      })
      return years
    },
    setYearSelect(del) {
      if (del && this.yearSelects.length === 1) {
        return
      }
      if (del) {
        this.yearSelects.pop()
        this.updateBoard()
        return
      }
      this.formData['year' + this.yearSelects.length] = null
      this.yearSelects.push('year' + this.yearSelects.length)
    },
  },
}
</script>
<style lang="scss" scoped></style>
